import { FormControlLabel, Switch, Tooltip } from '@mui/material';
import Box from '@mui/material/Box';
import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';

export const sxControllerSwitchLabel = {
  m: 0,
  width: 1,
  justifyContent: 'space-between',
};

type Props = {
  control: Control<any, any>;
  name: string;
  label?: string;
  disabled?: boolean;
  tooltipText?: string;
};

const ControllerSwitch: FC<Props> = ({ control, name, label, disabled = false, tooltipText }) => (
  <Controller
    name={name}
    control={control}
    render={({ field }) => {
      const controlEl = (
        <FormControlLabel
          key={name}
          label={label}
          labelPlacement="start"
          control={<Switch checked={field.value} onChange={field.onChange} disabled={disabled} />}
          sx={sxControllerSwitchLabel}
        />
      );
      return disabled && tooltipText ? (
        <Tooltip title={tooltipText} placement="bottom" arrow>
          <Box component="span">{controlEl}</Box>
        </Tooltip>
      ) : (
        controlEl
      );
    }}
  />
);

export default ControllerSwitch;
